/** Companies — edit form (RHF + zod + shadcn Form via Refine useForm). */
import { useForm } from "@refinedev/react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import {
  ENTITY_STATUS,
  updateCompanySchema,
  type Company,
  type UpdateCompanyInput,
} from "@aos/shared";

import { Form } from "@/components/ui/form";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";

import { PageHeader, LoadingState, ErrorState } from "../projects/_shared";
import { FormGrid, SelectField, TextField } from "../projects/_form";

export function CompanyEdit() {
  const form = useForm<Company, any, UpdateCompanyInput>({
    resolver: zodResolver(updateCompanySchema),
    refineCoreProps: { resource: "companies", action: "edit" },
  });

  const {
    refineCore: { formLoading, query },
    saveButtonProps,
    control,
  } = form;

  if (query?.isLoading) {
    return <LoadingState label="Loading company…" />;
  }
  if (query?.isError) {
    return <ErrorState error={query.error} />;
  }

  return (
    <div className="mx-auto max-w-3xl space-y-6">
      <PageHeader title="Edit Company" description="Update company details." />
      <Form {...form}>
        <form onSubmit={saveButtonProps.onClick}>
          <Card>
            <CardHeader>
              <CardTitle className="text-base">Company details</CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <FormGrid>
                <TextField control={control} name="name" label="Name" />
                <SelectField
                  control={control}
                  name="status"
                  label="Status"
                  options={ENTITY_STATUS}
                />
              </FormGrid>
            </CardContent>
            <CardFooter className="justify-end">
              <Button type="submit" disabled={formLoading}>
                {formLoading ? "Saving…" : "Save Changes"}
              </Button>
            </CardFooter>
          </Card>
        </form>
      </Form>
    </div>
  );
}

export default CompanyEdit;
